import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import Page from 'src/components/Page';
import Header from './Header';
import GreetingForm from '../GreetingNew/GreetingForm';
// import ProjectCreateForm from './ProjectCreateForm';
import MperitoCard from 'src/components/MperitoCard';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingTop: theme.spacing(3),
        paddingBottom: 100
    }
}));

function GreetingCreate() {
    const classes = useStyles();
    const { state } = useLocation();

    const businessInfo = useSelector((state) => state?.app?.businessInfo);
    const customerId = businessInfo?.customerId;

    useEffect(() => {

    }, [businessInfo]);

    return (
        <Page
            className={classes.root}
            title="Greeting Edit"
        >
            <Container maxWidth={false}>
                <Header />
                <MperitoCard title={`Edit Greeting ( ${businessInfo?.businessName} - ${businessInfo?.customerId} )`}>
                    <GreetingForm customerId={customerId} data={state}/>
                </MperitoCard>
            </Container>
        </Page>
    );
}

export default GreetingCreate;